import { useQuery } from '@tanstack/react-query';
import apiClient from '../../lib/api';

/**
 * 患者の最新連絡帳日付を取得するカスタムフック
 * @param patientId 患者ID
 * @returns React Query の結果
 */
export const useLatestContactLogDate = (patientId: number | null) => {
  return useQuery({
    queryKey: ['latestContactLogDate', patientId],
    queryFn: async () => {
      if (!patientId) {
        throw new Error('Patient ID is required');
      }
      return await apiClient.getLatestContactLogDate(patientId);
    },
    // 患者IDがnullの場合は実行しない
    enabled: patientId !== null && !!apiClient.getIdToken(),
    // エラー時のリトライ設定
    retry: 1,
    // データがない場合も正常なケースとして扱う
    retryOnMount: false,
  });
};

export default useLatestContactLogDate;
